<form [formGroup]="searchForm" class="flex relative header-site-search grow" (ngSubmit)="onSubmit()">
  @if (!isNewBrand() && !searchButtonIconOnly()) {
    <fcom-button
      class="z0 site-search-expand flex--self-center"
      data-testid="header-search-button"
      [class.is-vishidden]="inputExpanded()"
      [aria]="{
        controls: 'site-navigation-search-field-' + context(),
        expanded: inputExpanded(),
        hidden: inputExpanded(),
      }"
      [icon]="{
        name: SvgLibraryIcon.SEARCH,
        position: IconPosition.LEFT,
      }"
      [text]="'siteSearch.search' | finLocalization"
      [theme]="ButtonTheme.TERTIARY_GHOST_REVERSED"
      (clickBtn)="expandSearch()"
    />
  }
  <input
    class="form-control flex-1 light-type flex--self-center font-body-medium"
    id="site-navigation-search-field-{{ context() }}"
    [ngClass]="{
      'expanded ps-xxsmall-l ps-medium-r': inputExpanded(),
      narrow: enableNewLanguageSelector(),
    }"
    [attr.tabindex]="!inputExpanded() ? -1 : null"
    [attr.aria-label]="'siteSearch.search' | finLocalization"
    [attr.aria-hidden]="inputExpanded() ? false : true"
    (blur)="onBlur()"
    [placeholder]="'siteSearch.search' | finLocalization"
    #headerQueryField
    formControlName="searchKey"
    data-testid="header-search-input"
  />
  @if (!searchButtonIconOnly()) {
    @if (isNewBrand()) {
      <fcom-button
        class="z0 flex--self-center site-search-submit"
        data-testid="header-text-search-button-submit"
        [aria]="{
          controls: 'site-navigation-search-field-' + context(),
          expanded: inputExpanded(),
          label: inputExpanded() ? ('siteSearch.search' | finLocalization) : null,
        }"
        [icon]="{
          name: SvgLibraryIcon.SEARCH,
          position: IconPosition.LEFT,
        }"
        [theme]="ButtonTheme.TERTIARY_GHOST"
        [type]="inputExpanded() ? ButtonType.SUBMIT : ButtonType.BUTTON"
        [text]="'siteSearch.search' | finLocalization"
        (clickBtn)="!inputExpanded() ? expandSearch() : null"
      />
    } @else {
      <fcom-button
        class="z0 absolute flex--self-center site-search-submit"
        data-testid="header-text-search-button-submit"
        [class.is-vishidden]="!inputExpanded()"
        [aria]="{
          controls: 'site-navigation-search-field-' + context(),
          expanded: inputExpanded(),
          hidden: !inputExpanded(),
        }"
        [icon]="{
          name: SvgLibraryIcon.SEARCH,
          position: IconPosition.LEFT,
        }"
        [theme]="ButtonTheme.TERTIARY_GHOST_REVERSED"
        [type]="ButtonType.SUBMIT"
        [text]="'siteSearch.search' | finLocalization"
      />
    }
  }

  @if (searchButtonIconOnly()) {
    <fcom-icon-button
      class="z0 absolute flex--self-center site-search-submit"
      data-testid="header-icon-search-button-submit"
      [icon]="{
        name: SvgLibraryIcon.SEARCH,
      }"
      [aria]="{
        controls: 'site-navigation-search-field-' + context(),
        expanded: inputExpanded(),
        hidden: !inputExpanded(),
        label: 'siteSearch.search' | finLocalization,
      }"
      [size]="IconButtonSize.SMALL"
      [theme]="IconButtonTheme.TERTIARY_GHOST"
      [type]="ButtonType.SUBMIT"
      (clickBtn)="expandSearch()"
    />
  }
</form>
